import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

// Solo los administradores crean cuenta; los propietarios entran con las
// credenciales que les entrega su administrador al registrarlos.
const OwnerAccessNotice = ({ variant, className }) => (
  <Alert color="info" className={`fs--1 d-flex text-left mb-0 ${className}`}>
    <FontAwesomeIcon icon={faInfoCircle} className="mr-2 mt-1 flex-shrink-0" />
    <div>
      <strong className="d-block mb-1">¿Eres propietario?</strong>
      {variant === 'register' ? (
        <>
          Este registro es solo para administradores de condominio. No necesitas crear una cuenta:
          pídele al administrador de tu condominio que lo registre en Homelan y te proporcione tu
          usuario y contraseña. <Link to="/authentication/login">Ya tengo mis credenciales</Link>
        </>
      ) : (
        <>
          Inicia sesión con el usuario y contraseña que te proporcionó el administrador de tu
          condominio. Si aún no los tienes, solicítale que registre tu condominio en Homelan.
        </>
      )}
    </div>
  </Alert>
);

OwnerAccessNotice.propTypes = {
  variant: PropTypes.oneOf(['login', 'register']),
  className: PropTypes.string,
};

OwnerAccessNotice.defaultProps = {
  variant: 'login',
  className: '',
};

export default OwnerAccessNotice;
